import React from 'react';
import IntroImg from '../../assets/Blogging.svg';

const Blogs = () => {
    return(
        <div>
            <div className='blogs-section'>
                <div className='blogs-title'>
                    Blogs
                </div>
                <div className='blogs-image-container'>
                    <img src={IntroImg} className='blogs-image'/>
                </div>
                <div className='blogs-container'>
                    <div className='blog-card'>
                        Blog 1
                    </div>
                    <div className='blog-card'>
                        Blog 2
                    </div>
                    <div className='blog-card'>
                        Blog 3
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Blogs;